/*
 *
 * Profile
 *
 */

import "../styles.scss";

import { API, Endpoints } from "utils/api";
import { Col, Input, Pagination, Row, Select, Tabs, notification } from "antd";
import { Icons, PhoneInput } from "components";
import { setBreadcrumb, setLoader, setUser } from "store/actions";

import { Footer } from "screens";
import { Helmet } from "react-helmet";
import Password from "components/Password";
import ProfileImagePlaceholder from "assets/images/placeholders/doctor.jpg";
import React from "react";
import Strings from "utils/strings";
// @ts-ignore
import Variables from "styles/variables.scss";
import { connect } from "react-redux";
import moment from "moment";
import { replace } from "connected-react-router";
import { translate } from "utils/utils";

export class Profile extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			activeTab: "profile",

			...this.props.user,

			newEmail: "",

			password: "",
			newPassword: "",
			showPassword: false,
			showNewPassword: false,

			about: "",
			editing: false,
			defaultSkills: [],
			reviews: [],
			page: 1,
			pageSize: 3,

			languages: [],
			languageOptions: [],
            isPasswordValid: false,
		};
	}

	componentDidMount() {
		const {
			dispatch,
			match: { params }
		} = this.props;

		dispatch(
			setBreadcrumb(() => ({
				locations: [
					{
						text: Strings.sidebar.profile,
						route: "/profile"
					}
				]
			}))
		);

		this.getData(Boolean(params?.code));
	}

	async getData(confirmEmail: boolean = false) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		if (confirmEmail) {
			await Promise.all([this.confirmEmail(), this.getProfile(), this.getSkills(), this.getLanguageOptions()]);
		} else {
			await Promise.all([this.getProfile(), this.getSkills(), this.getLanguageOptions()]);
		}

		dispatch(setLoader(false));
	}

	async getLanguageOptions() {
		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriLanguages()
			});

			if (response.ok) {
				const { languages } = response.data.results || {};

				this.setState({ languageOptions: languages || [] });
			} else {
				notification.error({
					message: Strings.sidebar.profile,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.profile,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	async getProfile() {
		const { dispatch } = this.props;

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriProfile("me")
			});

			if (response.ok) {
				const { psychologist } = response.data.results || {};
				dispatch(setUser(psychologist));

				this.setState({ ...psychologist });
			} else {
				notification.error({
					message: Strings.sidebar.profile,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.profile,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	async getSkills() {
		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriSkills()
			});

			if (response.ok) {
				const { diagnosis: defaultSkills } = response.data.results || {};
				this.setState({ defaultSkills });
			} else {
				notification.error({
					message: Strings.sidebar.profile,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.profile,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	async confirmEmail() {
		const { newEmail, password } = this.state;
		const {
			dispatch,
			match: { params }
		} = this.props;

		const body = {} as any;

		if (params?.code) {
			body.code = params.code;
		} else {
			if (!newEmail) {
				return notification.warn({
					message: Strings.sidebar.profile,
					description: Strings.profile.emailEmpty,
					placement: "bottomRight",
					duration: 5
				});
			}

			if (!password) {
				return notification.warn({
					message: Strings.sidebar.profile,
					description: Strings.profile.passwordEmpty,
					placement: "bottomRight",
					duration: 5
				});
			}

			body.newEmail = newEmail;
			body.password = password;
		}

		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriChangeEmail(params.code),
				data: body
			});

			if (response.ok) {
				if (params?.code) {
					const { user } = response.data.results || {};
					this.setState({ ...user });
					dispatch(setUser(user));
					dispatch(replace("/profile"));

					notification.success({
						message: Strings.sidebar.profile,
						description: Strings.profile.emailChange,
						placement: "bottomRight",
						duration: 5
					});
				} else {
					this.setState({ newEmail: "", password: "", showPassword: false });

					notification.success({
						message: Strings.sidebar.profile,
						description: Strings.profile.emailSent,
						placement: "bottomRight",
						duration: 5
					});
				}
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.profile,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	profileIsValid() {
		const { name } = this.state;

		if (!name || !name.trim()) {
			notification.warn({
				message: Strings.errors.invalidFields,
				description: Strings.errors.nameIsEmpty,
				placement: "bottomRight",
				duration: 5
			});

			return false;
		}

		return true;
	}

	async saveProfile() {
		const { externalName, email, phone, photo, skills, about, languages } = this.state;
		const { dispatch } = this.props;

		if (this.profileIsValid()) {
			const body = {
				externalName,
				email,
				about,
				skills,
				languages,
				photo: photo || "",
				phone: phone || ""
			};

			dispatch(setLoader(true));

			const response = await API.put({
				url: Endpoints.uriProfile(),
				data: body
			});

			if (response.ok) {
				const { psychologist: newUser } = response.data.results;
				dispatch(setUser({ ...newUser }));

				notification.success({
					message: Strings.profile.header,
					description: Strings.profile.saved,
					placement: "bottomRight",
					duration: 5
				});

				this.setState({ ...newUser, editing: false });
			}

			dispatch(setLoader(false));
		}
	}

	passwordIsValid() {
		const { password, newPassword } = this.state;

		if (!password || !password.trim() || !newPassword || !newPassword.trim()) {
			notification.warn({
				message: Strings.errors.invalidFields,
				description: Strings.errors.pleaseFillFormCorrectly,
				placement: "bottomRight",
				duration: 5
			});

			return false;
		}

		return true;
	}

	async changePassword() {
		const { password, newPassword } = this.state;
		const { dispatch } = this.props;

		if (this.passwordIsValid()) {
			const body = {
                currentPassword: password,
                password: newPassword
            }

			dispatch(setLoader(true));

			let response: any;
			try {
				response = await API.put({
					url: Endpoints.uriProfile(),
					data: body
				});

				if (response.ok) {
					notification.success({
						message: Strings.profile.header,
						description: Strings.authentication.passwordChanged,
						placement: "bottomRight",
						duration: 5
					});

					this.setState({ password: "", newPassword: "", showPassword: false, showNewPassword: false });
				} else {
					notification.error({
						message: Strings.sidebar.profile,
						description: response.data?.message || Strings.serverErrors.requestNotPossible,
						placement: "bottomRight",
						duration: 5
					});
				}
			} catch (err) {
				notification.error({
					message: Strings.sidebar.profile,
					description: response.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}

			dispatch(setLoader(false));
		}
	}

	renderInfo() {
		const { externalName, email, phone } = this.state;

		return (
			<div className="ProfileDetails">
				<Row gutter={[0, 20]}>
					<Col xs={24}>
						<label htmlFor="profile_input" className="InputLabel --label-required">
							{Strings.fields.name}
						</label>
						<Input
							id="profile_input"
							value={externalName || ""}
							className="ProfileInput"
							placeholder={Strings.fields.name}
							onChange={(e: any) => this.setState({ externalName: e.target.value })}
						/>
					</Col>
					<Col xs={24}>
						<label htmlFor="profile_email" className="InputLabel">
							{Strings.authentication.email}
						</label>
						<Input
							id="profile_email"
							value={email || ""}
							className="ProfileInput"
							readOnly
							placeholder={Strings.authentication.email}
							onChange={(e: any) => this.setState({ email: e.target.value })}
						/>
					</Col>
					<Col xs={24}>
						<label htmlFor="profile_phone" className="InputLabel">
							{Strings.profile.phone}
						</label>
						<PhoneInput
							id="profile_phone"
							defaultCountry="pt"
							value={phone || ""}
							containerClass="react-tel-input ProfilePhoneInput"
							onChange={(phone: any) => {
								this.setState({ phone });
							}}
						/>
					</Col>
				</Row>
				<div className="ProfileButtons">
					<button className="ProfileButton --btn-primary" onClick={() => this.saveProfile()}>
						{Strings.generic.save}
					</button>
				</div>
			</div>
		);
	}

	renderPassword() {
		const { password, newPassword, showPassword, showNewPassword, isPasswordValid } = this.state;

		return (
			<div className="ProfileDetails">
				<Row gutter={[0, 20]}>
					<Col xs={24}>
						<label htmlFor="profile_password" className="InputLabel --label-required">
							{Strings.authentication.actualPassword}
						</label>
						<Input
							id="profile_password"
							value={password || ""}
							type={showPassword ? "text" : "password"}
							className="ProfileInput"
							suffix={
								<button
									className="PasswordInputEye"
									onClick={(e: any) => {
										e.preventDefault();
										e.stopPropagation();
										this.setState((prevState: any) => ({ showPassword: !prevState.showPassword }));
									}}
								>
									<Icons.Eye />
								</button>
							}
							placeholder={Strings.authentication.actualPassword}
							onChange={(e: any) => this.setState({ password: e.target.value })}
						/>
					</Col>
					<Col xs={24}>
						<label htmlFor="profile_new_password" className="InputLabel --label-required">
							{Strings.profile.newPassword}
						</label>
						<Password
							className="ProfileInput"
							password={newPassword || ""}
							showPassword={showPassword}
							onPasswordChange={(newPassword: string, isValid: boolean) => {
								this.setState({ newPassword: newPassword, isPasswordValid: isValid });
							}}
							onShowPasswordChange={(value: boolean) => this.setState({ showPassword: value })}
							placeholder={Strings.profile.newPassword}
						/>
					</Col>
				</Row>
				<div className="ProfileButtons">
					<button
						className="ProfileButton --btn-primary"
						onClick={() => this.changePassword()}
						disabled={!password || !newPassword || !isPasswordValid}
					>
						{Strings.fields.update}
					</button>
				</div>
			</div>
		);
	}

	renderProfile() {
		const { editing, about, skills, defaultSkills, languageOptions, languages } = this.state;

		return (
			<div className="ProfileDetails">
				<Row gutter={[0, 10]}>
					<Col xs={24}>
						<label htmlFor="profile_input" className="InputLabel">
							{Strings.fields.about}
						</label>
						{editing ? (
							<Input.TextArea
								id="profile_input"
								value={about || ""}
								rows={5}
								className="ProfileInput ProfileTextareaMax700"
								placeholder={editing ? Strings.fields.about : Strings.profile.noAbout}
								onChange={(e: any) => this.setState({ about: e.target.value })}
							/>
						) : (
							<p className="ProfileAbout ProfileAboutMax700">
								{about ? about : Strings.profile.noAbout}
							</p>
						)}
					</Col>
					<Col xs={24}>
						<label htmlFor="profile_input" className="InputLabel">
							{Strings.profile.competencies}
						</label>
						<Select
							mode="multiple"
							className="ProfileInputMax700"
							allowClear
							placeholder={editing ? Strings.placeholders.selectSkills : Strings.profile.noSkills}
							value={skills}
							disabled={!editing}
							onChange={(value: any) => this.setState({ skills: value })}
						>
							{defaultSkills.map((skill: any) => (
								<Select.Option value={skill._id} key={`skill_${skill._id}`}>
									{translate(skill.name)}
								</Select.Option>
							))}
						</Select>
					</Col>
					<Col xs={24}>
						<label htmlFor="profile_languages" className="InputLabel">
							{Strings.profile.languages}
						</label>
						<Select
							id="profile_languages"
							className="ProfileInputMax700"
							mode="multiple"
							optionFilterProp="children"
							allowClear
							showSearch
							placeholder={editing ? Strings.placeholders.selectLanguages : Strings.profile.noLanguages}
							value={languages || null}
							disabled
							onChange={(value: any) => this.setState({ languages: value })}
						>
							{languageOptions.map((lang: any) => (
								<Select.Option value={lang._id} key={`language_${lang._id}`}>
									{lang.name}
								</Select.Option>
							))}
						</Select>
					</Col>
					<Col xs={24}>
						{editing ? (
							<div className="ProfileMultiButtons">
								<button className="ProfileButton" onClick={() => this.saveProfile()}>
									{Strings.generic.save}
								</button>
								<button
									className="ProfileButton"
									onClick={() =>
										this.setState((prevState: any) => ({
											about: JSON.parse(JSON.stringify(prevState.backupAbout)),
											skills: JSON.parse(JSON.stringify(prevState.backupSkills)),
											editing: false
										}))
									}
								>
									{Strings.appointments.cancel}
								</button>
							</div>
						) : (
							<button
								className="ProfileButton"
								onClick={() =>
									this.setState((prevState: any) => ({
										editing: true,
										backupAbout: JSON.parse(JSON.stringify(prevState.about)),
										backupSkills: JSON.parse(JSON.stringify(prevState.skills))
									}))
								}
							>
								{Strings.fields.edit}
							</button>
						)}
					</Col>
				</Row>
			</div>
		);
	}

	renderReviews() {
		const { reviews, page, pageSize } = this.state;

		return (
			<div className="ProfileDetails">
				<div className="ReviewsContainer">
					{reviews.length > 0 &&
						reviews
							.slice(0 + pageSize * (page - 1), pageSize + pageSize * (page - 1))
							.map((review: any, index: number) => (
								<div key={`review_${index}`} className="ReviewWrapper">
									<div className="ReviewRating">
										{Array(5)
											.fill("")
											.map((star: string, index: number) => {
												let className = "";
												if (index + 1 <= review.rating) {
													className = "-btn--selected";
												}

												return (
													<button key={`star_${index}`} className={className}>
														<Icons.Star small />
													</button>
												);
											})}
									</div>
									<p data-date>{moment.utc(review.date).format("DD MMMM YYYY")}</p>
									<p data-text>{review.message}</p>
								</div>
							))}
					{reviews.length === 0 && <p>{Strings.profile.noReviews}</p>}
				</div>
				{reviews.length > 0 && (
					<div className="ReviewsPagination">
						<Pagination
							total={reviews.length}
							current={page}
							pageSize={pageSize}
							onChange={(value: any) => this.setState({ page: value })}
						/>
					</div>
				)}
			</div>
		);
	}

	render() {
		const { photo, activeTab, reviews, rating = 0 } = this.state;
		const { user, mobile } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.generic.profile}</title>
					<meta name="description" content="Description of Profile" />
				</Helmet>
				<div className="ProfileContent">
					<h1 className="GenericTitle">{Strings.generic.profile}</h1>
					<div className="ProfileDivision">
						<div className="ProfilePictureWrapper --profile-psychologist">
							<img src={photo || ProfileImagePlaceholder} alt="profile avatar" />
							<h3>{user?.externalName || "-"}</h3>
							<p>{Strings.profile.psychologist}</p>
							<div className="ProfileCardRating">
								<p>
									{reviews || 0} {reviews === 1 ? Strings.profile.review : Strings.profile.reviews}
								</p>
								<div className="ProfileRatingStars">
									{Array(5)
										.fill("")
										.map((star: string, index: number) => {
											let className = "";
											if (index + 1 <= rating) {
												className = "-btn--selected";
											}

											return (
												<button key={`star_${index}`} className={className}>
													<Icons.Star small />
												</button>
											);
										})}
								</div>
							</div>
						</div>
						<div className="ProfileSettings">
							<Tabs
								defaultActiveKey="profile"
								onChange={(key: string) => {
									if (key !== activeTab) {
										this.setState({
											activeTab: key,
											password: "",
											showPassword: false,
											newPassword: "",
											showNewPassword: false,
											newEmail: ""
										});
									}
								}}
								centered={mobile}
							>
								<Tabs.TabPane
									tab={
										<div className="TabIconContainer">
											<Icons.Profile
												tabs
												color={
													activeTab === "profile"
														? Variables.primaryColor
														: Variables.darkPrimaryColor
												}
											/>
											{mobile && activeTab === "profile" ? <p>{Strings.sidebar.profile}</p> : ""}
											{!mobile && <p>{Strings.sidebar.profile}</p>}
										</div>
									}
									key="profile"
								/>
								<Tabs.TabPane
									tab={
										<div className="TabIconContainer">
											<Icons.Pencil
												color={activeTab === "info" ? Variables.primaryColor : false}
											/>
											{mobile && activeTab === "info" ? <p>{Strings.profile.myAccount}</p> : ""}
											{!mobile && <p>{Strings.profile.myAccount}</p>}
										</div>
									}
									key="info"
								/>
								<Tabs.TabPane
									tab={
										<div className="TabIconContainer">
											<Icons.Lock
												tabs
												color={activeTab === "password" ? Variables.primaryColor : false}
											/>
											{mobile && activeTab === "password" ? (
												<p>{Strings.profile.changePassword}</p>
											) : (
												""
											)}
											{!mobile && <p>{Strings.profile.changePassword}</p>}
										</div>
									}
									key="password"
								/>
								{/* <Tabs.TabPane
									tab={
										<div className="TabIconContainer">
											<Icons.Star
												tabs
												color={
													activeTab === "reviews"
														? Variables.primaryColor
														: Variables.darkPrimaryColor
												}
											/>
											{mobile && activeTab === "reviews" ? <p>{Strings.profile.reviews}</p> : ""}
											{!mobile && <p>{Strings.profile.reviews}</p>}
										</div>
									}
									key="reviews"
								/> */}
							</Tabs>
							{activeTab === "profile" && this.renderProfile()}
							{activeTab === "info" && this.renderInfo()}
							{activeTab === "password" && this.renderPassword()}
							{/* {activeTab === "reviews" && this.renderReviews()} */}
						</div>
					</div>
				</div>
				{mobile && <Footer />}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	user: state.user,
	language: state.language,
	mobile: state.mobile
});

export default connect(mapStateToProps)(Profile);
